import React, {useEffect, useMemo, useRef, useState} from "react";
import {getDateFromISOString} from "../../../../../utils/getAge";
import {laborantService} from "../../../../../api/laborantService";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Select from "react-select";
import {Controller, useForm} from "react-hook-form";
import classes from './form.module.scss';
import classNames from 'classnames';
import errorMessage from "../../../../../const/Tost";
import PrintIcon from "@mui/icons-material/Print";
import {DirectionService} from "../../../../../api/directionService";
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

const ReferralCard = () => {
    const {id} = useParams();
    const iframeRef = useRef(null);

    const {
        register,
        formState: {errors},
        control,
    } = useForm();

    const regForm = useSelector(state => state.regForm);

    const values = useMemo(() => ({
        ...regForm,
        fields: [
            ...regForm.fields,
            {
                legend: 'Відділення закладу',
                id: 20,
                type: 'text',
                required: true,
                name: 'externalDepartmentId',
                dataType: 'directionData',
                options: true,
                props: []
            }
        ]
    }), [regForm]);
    const [filteredData, setFilteredData] = useState([]);
    const [status, setStatus] = useState();

    useEffect(() => {
        const getMatchedData = async() => {
            try{
                const matchedData = await laborantService.getDirection(id);
                setStatus(matchedData?.data?.status)
                const result = values?.fields
                    ?.sort((a, b) => a.id - b.id)?.map(key => {
                    const item = matchedData?.data?.[key?.name] || matchedData?.data?.patient?.[key?.name]
                    if (item){
                        if (key?.name === "antibodies"){
                            return item.length && {...key, value: item?.map(e => e.name)?.join(', '), show: true};
                        } else if (key?.name === "operationDate"){
                            return {...key, value: getDateFromISOString(item), show: true};
                        } else if (key?.name === "contractId"){
                            return {...key, type: "text", value: matchedData?.data?.contract?.name, show: true};
                        } else if (key?.name === "hospitalId"){
                            return {...key, type: "text", value: matchedData?.data?.hospital?.name, show: true};
                        } else if (key?.name === "externalDepartmentId"){
                            return {...key, type: "text", value: matchedData?.data?.externalDepartment?.name, show: true};
                        } else if (key?.name === "departmentId"){
                            return {...key, type: "text", value: matchedData?.data?.department?.name, show: true};
                        } else if (key?.name === "biopsy"){
                            return {...key, type: "text", value: item, show: true};
                        } else if (key?.name === "phoneNumber"){
                            return {...key, type: "text", value: item, defaultValue: item, show: true};
                        } else {
                            return {...key, value: item, show: true};
                        }
                    } else {
                        if (key?.name === "birthDate"){
                            return {...key,
                                props: key?.props?.map(e => (matchedData?.data[e?.name] && {
                                    ...e,
                                    value: matchedData?.data[e?.name] + ' ' + e?.placeholder
                                }))?.filter(e => e),
                                show: true,
                            }
                        }
                    }
                });
                setFilteredData(result?.filter(e => e));
            } catch(error){
                console.log(error)
                errorMessage('Error fetching matched data:', error?.response?.data);
            }
        };

        getMatchedData();
    }, [id, values]);

    const printHandler = async() => {
        if (id){
            await DirectionService.getDirectionHTML(id).then(res => {
                if (res?.data){
                    const iframe = iframeRef.current;
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    iframeDoc.open();
                    iframeDoc.write(res?.data);
                    iframeDoc.close();

                    iframe.onload = () => {
                        iframe.contentWindow.print();
                    };
                }
            })
        }
    }

    const printHandler1 = async() => {
        if (id){
            await DirectionService.getDirectionHTML1(id).then(res => {
                if (res?.data){
                    const iframe = iframeRef.current;
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    iframeDoc.open();
                    iframeDoc.write(res?.data);
                    iframeDoc.close();

                    iframe.onload = () => {
                        iframe.contentWindow.print();
                    };
                }
            })
        }
    }

    return (
        <div className={classes.form}>
            <div style={{display: "flex", justifyContent: "space-around", width: "100%"}}>
                <div style={{display: "flex", flexDirection: "column", alignItems: 'center', gap: '8px'}}>
                    <div>Роздрукувати направлення</div>
                    <PrintIcon onClick={() => printHandler()} className={classes.icon}/>
                </div>
                {status === "finished" &&
                    <div style={{display: "flex", flexDirection: "column", alignItems: 'center', gap: '8px'}}>
                        <div>Роздрукувати результат</div>
                        <ReceiptLongRoundedIcon onClick={() => printHandler1()} className={classes.icon}/>
                    </div>
                }
            </div>

            {filteredData?.map((el, index) => (
                <div className={classes[values.class]} key={index}>
                    <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                    <div className={classNames(classes.form__label__container, {[classes.cassets__container]: el.name === 'cassets'})}>
                        {el?.value && el?.name !== 'gender' && el?.name !== 'antibodies' ? (
                            <>
                                <label htmlFor={el.name}>{el.label}</label>
                                <input
                                    className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                    type={el.type}
                                    value={el.value || ''}
                                    {...register(el.name)}
                                    readOnly
                                />
                            </>
                        ) : el?.name === 'antibodies' ? (
                            <>
                                <label htmlFor={el.name}>{el.label}</label>
                                <div>
                                    <textarea
                                        className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                        type={el.type}
                                        readOnly
                                        value={el.value || ''}
                                        {...register(el.name)}
                                    />
                                </div>
                            </>
                        ) : el?.value && el?.name === 'gender' ? (
                            <Select
                                className={classes.select}
                                options={el.props.map(option => ({
                                    value: option.value,
                                    label: option.label
                                }))}
                                defaultValue={el.props.find(option => option.value === el.value)}
                                isDisabled={el.show}
                                placeholder="Виберіть значення..."
                                readOnly
                                {...register(el.name)}
                            />
                        ) : el.options ? (
                            <Controller
                                control={control}
                                name={el.name}
                                render={({field: {onChange, value}}) => (
                                    <Select
                                        className={classes.select}
                                        options={el.props}
                                        value={
                                            el?.name === 'antibodies'
                                                ? el.props.filter(option => value?.includes(option.id))
                                                : el.props.find(option => {
                                                return ['departmentId', 'hospitalId'].includes(el.name)
                                                    ? option.id === value
                                                    : el.name === 'gender'
                                                        ? option.value === value
                                                        : option.label === value;
                                            }) || null
                                        }
                                        onChange={(selectedOption) => {
                                            if (el.name === 'antibodies'){
                                                const newValue = selectedOption.map(option => {
                                                    return ['departmentId', 'hospitalId', 'antibodies'].includes(el.name)
                                                        ? option.id
                                                        : option.value;
                                                });
                                                onChange(newValue);
                                            } else {
                                                const newValue = ['departmentId', 'hospitalId'].includes(el.name)
                                                    ? selectedOption.id
                                                    : el.name === 'gender'
                                                        ? selectedOption.value
                                                        : selectedOption.label;
                                                onChange(newValue);
                                            }
                                        }}
                                        isMulti={el.name === 'antibodies'}
                                        disableSearch
                                        hasSelectAll={false}
                                        placeholder="Виберіть значення..."
                                        getOptionLabel={option => option.label}
                                        getOptionValue={option => option.id}
                                        readOnly
                                    />
                                )}
                            />
                        ) : (
                            el?.props?.map((props, i) => (
                                <div className={classNames(classes.form__label__container__box)} key={'a' + i}>
                                    <div><label>{props.label}</label></div>
                                    <div>
                                        {el.name === 'clinicalConclusion' || el.name === 'clinicalInfo' ? (
                                            <textarea
                                                className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                placeholder={props.placeholder}
                                                disabled={props.show}
                                                {...register(el.name)}
                                                value={el.type === 'radio' ? props.label : props.value}
                                                readOnly
                                            />
                                        ) : (
                                            <input
                                                className={classNames(classes.form__input)}
                                                style={el.name === 'birthDate' ? {width: '50px'} : {}}
                                                type={el.name === 'birthDate' ? 'text' : props.type}
                                                min={props.min}
                                                placeholder={props.placeholder}
                                                pattern={props.pattern}
                                                defaultValue={props.defaultValue}
                                                maxLength={el.name === 'phoneNumber' && props.max}
                                                disabled={props.show}
                                                value={el.type === 'radio' ? props.label : props.value}
                                                {...register(props?.name || el.name)}
                                                readOnly
                                            />
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            ))}
            <iframe ref={iframeRef} style={{display: 'none'}}/>
        </div>
    );
};

export default ReferralCard;
